module.exports = __webpack_public_path__ + "static/coderdojoteam-0ed8afc06676b9d722bc56689657131b.jpeg";